import { Component, OnInit, AfterViewInit, HostListener, OnDestroy } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { NgbCalendar, NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import * as $ from 'jquery';

// Service Class
import { LoaderService } from '../../../../services/infrastructure/loader.service';
import { BroadcastService } from '../../../../services/infrastructure/broadcaster.service';
import { ConfigService } from '../../../../services/infrastructure/config.service';
import { SeedReturnService } from '../../../../services/seed/seed-return.service';
import { LocalStorageService } from '../../../../services/infrastructure/local-storage.service';

// Class
import { DashboardFilter } from '../../../../models/DashboardFilter';
import { MasterConstants } from '../../../../common/constants/master-constants';
import { CommonService } from '../../../../services/common/common.service';

import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../../../../common/components/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-seed-returns-confirmation',
  templateUrl: './seed-returns-confirmation.component.html',
  styleUrls: ['./seed-returns-confirmation.component.scss']
})
export class SeedReturnsConfirmationComponent implements OnInit, AfterViewInit, OnDestroy {
  errorMsgs = new Array();
  showErrorBlock = false;
  currentErrorRow = 1;
  nextErrorId = 0;
  nextLotNumber: string;
  // Header selected values
  shipToAccount: number;
  deliveryAccount: number;
  deliveryAccountName: string;
  shipToAccountName: number;
  shipToAccountItems: any[];
  soldToAccountList: any[];
  soldToAccount: number;
  headerCompany = MasterConstants.US_COMPANYCODE;
  cropYear: any;
  dashboardFilter: DashboardFilter;
  originalProductItemsDataSource: any;
  searchValue = '';
  partialSearchValue = '';
  invoiceNumberList: any = [];
  productAllDataSource: any;
  splitDataSource: any = [];
  displayedColumns: string[] = this.seedReturnService.isReturnTypeForInnoculant ?
    ['checkbox', 'product', 'itemNumber', 'uom', 'units', 'dumpedUnits', 'notes'] :
    ['checkbox', 'product', 'itemNumber', 'lotNumber', 'uom', 'units', 'dumpedUnits', 'notes'];
  isParent: boolean = false;
  requestOnBehalfList: any = [];
  requestedByUser: string;
  currentRequestedUser: string;
  shipToDataLoading = true;
  index: any;
  returnRequestNumber = 0;
  returnRequestId = 0;
  accountEmail: string;
  readOnlyAccess = false;
  userMenuAccessList: any;
  dsmInfo: string;
  productList: any[];
  userIdRole: string;
  isApprovalAccess = false;
  createRequestAccess = false;
  editApprovalList: any = {};
  roleType: string;
  enableCreate = true;
  requestStatus: string;
  isValidLineStatus = false;

  isPickupDateValid = true;
  isNameValid: boolean;
  isContactValid: boolean;
  isPalletValid: boolean;

  showSubmitToJde = false;
  showSubmitReturn = false;
  breadcrumbtext: string;
  showScaleDelete = false;
  marketingBrandMasterList: any[];
  packageSizeMasterList: any = [];
  seedSizeMasterList: any = [];
  treatmentMasterList: any[];
  technologyMasterList: any[];
  showDelete = false;
  onBehalfUser: any;
  onBehalfUserName: string;
  selectedUserName: string;
  validateEvolveData: any;
  disableRejectedLine = true;
  isIncreaseQtyEnable = true;
  isDecreaseQtyEnable = true;
  selectedProductLineValue: string;
  selectedProductLineText: string;
  selectedProductLineId: string;
  mandatoryFieldSymbol: any = '';
  isShowNonSubEmail: boolean = true;
  isReturnTypeForInnoculant: boolean = false;

  public desiredPickupDate: any;
  public contactName: string;
  public contactNumber: string;
  public customerPONumber = 'Return';
  public shippingInstructions: string;
  public selectedFreightInstruction: string;
  public selectedFreightInstructionName: string;
  public palletCount: number;
  public emptyPalletCount: number;
  public emptyBoxCount: number;
  public emptyPallet: string;
  public emptyCBox: string;

  private subscription = new Subscription();

  public rdProduct: boolean = null;
  public rdEmptyCBox: boolean = null;
  public rdEmptyPallet: boolean = null;
  public isShowPickInfo = false;
  public totalProductCount: number = 0;

  public shouldShowSurveyMessage: boolean = false;
  public evolveSurveyUrl: string = '';

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private loaderService: LoaderService,
    private broadcastService: BroadcastService,
    private configService: ConfigService,
    public seedReturnService: SeedReturnService,
    public config: NgbDatepickerConfig,
    public configDate: NgbCalendar,
    private localStorageService: LocalStorageService,
    private commonService: CommonService,
    private matDialog: MatDialog) {
    this.dashboardFilter = new DashboardFilter();
  }

  ngOnInit() {
    this.requestStatus = this.seedReturnService.returnRequestStatus;
    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.cropYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    }

    this.subscription.add(this.seedReturnService.SelectedProductLineId.subscribe(x => {
      if (x && x != '') {
        this.selectedProductLineValue = this.seedReturnService.getProductLineValueById(x);
        this.selectedProductLineText = this.seedReturnService.getProductLineTextById(x);
        this.selectedProductLineId = x;
      }
      else {
        this.router.navigate(['/seed-returns-dashboard/All']);
      }
    }));

    if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
      const data = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      if (data !== null && data !== undefined && data.resultData.length > 0) {
        const isActiveUser = data.resultData.find(x => x.userIdCompanyCode == this.headerCompany);
        if (!isActiveUser.isSubscriptionAccess) {
          this.isShowNonSubEmail = false;
        } else {
          this.isShowNonSubEmail = true;
        }
        this.userIdRole = data.resultData.find(x => x.userIdCompanyCode == this.headerCompany).userIdRole;
        this.userMenuAccessList = data.resultData.find(x => x.userIdCompanyCode == this.headerCompany).userMenuAccessList;
        if (this.userMenuAccessList && this.userMenuAccessList.length > 0) {
          this.readOnlyAccess = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.RETURN_REQUEST_INVENTORY_PROTECTION, MasterConstants.USER_ACCESS.READ_ONLY, this.userMenuAccessList) || this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.RETURN_REQUEST_IP_APPROVAL, MasterConstants.USER_ACCESS.READ_ONLY, this.userMenuAccessList);
          this.isApprovalAccess = this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.RETURN_REQUEST_IP_APPROVAL);
          this.createRequestAccess = this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.RETURN_REQUEST_INVENTORY_PROTECTION);

          this.roleType = data.resultData.find(x => x.userIdCompanyCode == this.headerCompany).roleType.toUpperCase();
          this.isReturnTypeForInnoculant = this.seedReturnService.isReturnTypeForInnoculant
          //Get Return Request Id from URL
          this.subscription.add(this.activatedRoute.params.subscribe(x => {
            this.errorMsgs = [];
            if (x['returnRequestNumber']) {
              this.returnRequestNumber = +x['returnRequestNumber'];
              this.evolveSurveyUrl = this.seedReturnService.evolveSurveyUrl;
              this.shouldShowSurveyMessage = this.seedReturnService.shouldShowSurveyMessage;
              this.getOrderDetails();
            }
            else {
              this.enableCreate = true;
            }
          }));
        }
        this.enableCreate = true;
      }
    }

    // this.loadMasterData();
    this.productAllDataSource = new MatTableDataSource([]);
    this.seedReturnService.setEditModeStatus(false);
    this.errorMsgs = new Array();

    this.fetchReturnMasterData();
  }

  // Bind data source
  bindDataSource(orderList: any, isClone: boolean) {
    if (orderList && orderList != null) {
      this.splitDataSource = orderList;
    }
  }

  // Added Window onresize
  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setHeight();
  }

  // Design
  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setHeight();
  }

  // Design : Set height
  setHeight() {
    const createTemplateHeight = window.innerHeight - $('.navbar').outerHeight() - $('.SeedFulfillBtnSec').outerHeight();
    $('.create-return-outer').css('max-height', createTemplateHeight + 'px');
  }

  // Get Order Details when opened in Edit/View Mode
  getOrderDetails() {
    this.loaderService.setLoaderStatus(true);
    this.subscription.add(this.seedReturnService.getEditRequestDetail(this.returnRequestId, this.returnRequestNumber).subscribe((result: any) => {
      this.breadcrumbtext = 'Return Request [' + this.returnRequestNumber + ']';
      this.returnRequestId = result.returnRequestId;
      this.seedReturnService.setEditModeStatus(true);
      this.isPickupDateValid = true;
      this.isNameValid = true;
      this.isContactValid = true;
      this.isPalletValid = true;
      this.seedReturnService.returnRequestStatus = result.returnRequestStatus;
      this.accountEmail = result.email;
      this.requestStatus = result.returnRequestStatus;
      this.enableCreate = false;
      this.editApprovalList = result;

      if (result.splitDetails && result.splitDetails.length > 0) {
        result.splitDetails.forEach(x => {
          x.productDetail.forEach(prod => {
            prod.eligibleUnit = prod.isManualLine ? 0 : prod.eligibleUnit;
          });
          this.totalProductCount += x.productDetail && x.productDetail.length > 0 ? x.productDetail.length : 1;
        });
      }
      this.returnRequestNumber = result.returnRequestNumber;
      this.shipToAccount = result.shipToAccountId;
      this.shipToAccountName = result.shipToAccountName;
      this.seedReturnService.setSelectedAccountNo(this.shipToAccount);
      this.dsmInfo = result.dsmName;
      this.isParent = result.isParent;
      this.seedReturnService.setProductList(result.spli);
      this.originalProductItemsDataSource = [];
      this.bindDataSource(result.splitDetails, true);
      this.originalProductItemsDataSource = JSON.parse(JSON.stringify(result.splitDetails));
      this.requestedByUser = result.requestedBy;
      this.onBehalfUser = result.requestedBy;
      this.shipToAccountItems = [result.shipToAccountDetail];
      this.soldToAccount = Number(result.shipToAccountDetail.soldTo);
      this.getUserList(this.shipToAccount);

      this.rdProduct = result.productsToReturn;
      if (this.rdProduct === true) {
        this.mandatoryFieldSymbol = '';
      }
      else {
        this.mandatoryFieldSymbol = '*';
      }
      this.rdEmptyCBox = result.emptyCbox;
      this.rdEmptyPallet = result.emptyPallet;
      this.isShowPickInfo = this.rdProduct || this.rdEmptyPallet || this.rdEmptyCBox;

      this.seedReturnService.setSelectedAccountNo(result.shipToAccountId);
      this.contactName = result.pickupInfo.contactName;
      this.contactNumber = result.pickupInfo.contactNumber;
      this.customerPONumber = result.pickupInfo.custPONumber;
      this.palletCount = result.pickupInfo.palletCount;
      this.emptyPalletCount = result.pickupInfo.emptyPalletCount;
      this.emptyBoxCount = result.pickupInfo.emptyCboxCount;
      this.desiredPickupDate = new Date(result.pickupInfo.requestDate);
      this.deliveryAccount = result.pickupInfo.pickUpLocation;
      this.deliveryAccountName = result.pickupInfo.pickUpLocationName;
      this.shippingInstructions = result.pickupInfo.shippingInstructions;
      this.selectedFreightInstruction = result.pickupInfo.freightInstructions;
      this.selectedFreightInstructionName = result.pickupInfo.freightInstructionsDescription;

      if (this.shouldShowSurveyMessage) {
        this.showSurveyMessage();
      }
      this.loaderService.setLoaderStatus(false);
    }, error => this.loaderService.setLoaderStatus(false)));
  }

  getUserList(accountNumber) {
    const self = this;
    this.subscription.add(this.seedReturnService.getAccountUser(accountNumber).subscribe((result: any) => {
      if (result.length > 0) {
        result.filter(x => {
          const accountNameArr = x.userName.split(',');
          if (accountNameArr.length > 1) {
            x.userName = accountNameArr[1] + ' ' + accountNameArr[0];
          }
        });
        this.requestOnBehalfList = result;
        if (this.onBehalfUser) {
          const requestItem = this.requestOnBehalfList.filter(r => r.userId == this.onBehalfUser);
          if (requestItem && requestItem.length > 0) {
            this.onBehalfUserName = requestItem[0].userName;
            this.accountEmail = this.isShowNonSubEmail ? this.accountEmail : requestItem[0].userEmail;
            this.requestedByUser = requestItem[0].userId;
          }
        }
        if (self.onBehalfUser && self.requestOnBehalfList.filter(r => r.userId == self.onBehalfUser)[0] === undefined) {
          self.accountEmail = null;
          self.onBehalfUser = null;
        }
      }
    }, error => this.loaderService.setLoaderStatus(false)));
  }

  fetchReturnMasterData() {
    if (this.headerCompany && this.selectedProductLineId) {
      this.subscription.add(this.seedReturnService.getReturnMaster(this.selectedProductLineId)
        .subscribe(result => {
          if (result) {
            this.emptyPallet = result.emptyPallet;
            this.emptyCBox = result.emptyCbox;
          }
        }, error => this.loaderService.setLoaderStatus(false))
      );
    }
  }

  backToReturnList() {
    this.router.navigate([`/seed-returns-dashboard/${this.seedReturnService.dashboardSelectedProductLine}`]);
  }

  isShowOrderNumber(productItem): boolean {
    let isShow = false;
    if (productItem.jdeOrderNumber != null && productItem.jdeOrderNumber != '') {
      isShow = true;
    }
    return isShow;
  }

  // Generate PDF
  generatedPdf() {
    this.seedReturnService.generatePdf(0, this.returnRequestNumber);
  }

  showSurveyMessage() {
    const title = 'Evolve Survey';
    const message = 'We value your insights on the Evolve Order Management Application. Please take 2-3 minutes to complete this feedback survey and help us enhance your experience. Your responses are confidential. Thank you for participating!';
    const dialogRef = this.matDialog.open(ConfirmDialogComponent, {
      disableClose: true,
      width: '450px',
      panelClass: 'feedback-survey-dialog',
      data: { title: title, message: message, labelYes: 'Yes', labelNo: 'No', labelLater: 'Later', dialogType: 'surveyForm' }
    });

    this.subscription.add(dialogRef.afterClosed().subscribe((res: string) => {
      this.saveSurveyPreference(res);
    }));
  }

  saveSurveyPreference(userSurveyPref) {
    if (userSurveyPref === 'YES') {
      window.open(this.evolveSurveyUrl, '_blank', 'noopener,noreferrer');
    }
    this.loaderService.setLoaderStatus(true);
    var response = JSON.stringify(userSurveyPref);
    this.subscription.add(this.seedReturnService.saveSurveyPreference(response).subscribe((result: any) => {
      this.loaderService.setLoaderStatus(false);

    }, error => this.loaderService.setLoaderStatus(false)));
  }

  // On page destroy
  ngOnDestroy() {
    this.seedReturnService.setReturnRequestId(0);
    this.seedReturnService.shouldShowSurveyMessage = false;
    this.seedReturnService.evolveSurveyUrl = '';
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
